export function Spinner({ className = 'size-5' }: { className?: string }) {
  return (
    <span
      className={`inline-block animate-spin rounded-full border-2 border-beige-2 border-t-dark-purple ${className}`}
      role="status"
      aria-label="Laden"
    />
  )
}
